/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useParams } from "next/navigation";
import { useTranslation } from "../../../i18n/client";
import { useTaxClassificationChangeNotice } from "../hooks/useTaxClassificationChangeNotice";
import ConfirmationModal from "./ConfirmationModal";
export default function TaxClassificationChangeNotice() {
    const params = useParams();
    const { t } = useTranslation(params === null || params === void 0 ? void 0 : params.lng, "products");
    const { showTaxChangeModal, taxChangeNoticeType, handleCloseTaxChangeModal, showError, setShowError } = useTaxClassificationChangeNotice();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ConfirmationModal, {
                open: showTaxChangeModal,
                handleClose: handleCloseTaxChangeModal,
                title: t("tax_classification_change_title"),
                subtitle: taxChangeNoticeType === "to_yes" ? t("tax_classification_change_message_to_yes") : t("tax_classification_change_message_to_no"),
                primaryBtnName: t("ok"),
                primaryBtnAction: handleCloseTaxChangeModal
            }),
            /*#__PURE__*/ _jsx(ConfirmationModal, {
                title: "Error",
                subtitle: "An unknown error occured. Please try again",
                open: showError,
                handleClose: ()=>setShowError(false),
                primaryBtnName: "OK",
                primaryBtnAction: ()=>setShowError(false)
            })
        ]
    });
}
